<div class="dialog transfer-collection-dialog">
    <div class="dialog-title">
            <h2>{{ 'collection.dialog.transferownership'|translate }}</h2>
            <button mat-icon-button (click)="close()">
                <mat-icon  fontIcon="close"></mat-icon>
            </button>
    </div>
    <mat-dialog-content [formGroup]="userSearchForm">
        <h3 class="mb-3">{{ 'collection.transfer.text'|translate }}</h3>
        <mat-form-field>
            <mat-label>{{ 'collection.transfer.principals.placeholder'|translate }}</mat-label>
            <input matInput [matAutocomplete]="auto" formControlName="search">
        </mat-form-field>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectUser($event)" [displayWith]="displayUser">
            @for (user of userSuggestions; track user.id) {
                <mat-option [value]="user">
                    <span>{{ user.fullName }}</span>
                </mat-option>
            }
        </mat-autocomplete>
        <div class="btn-row">
            <button mat-button (click)="close()">{{ 'button.cancel'|translate }}</button>
            <button mat-raised-button (click)="confirm()" [disabled]="!canConfirm()">{{ 'button.save'|translate }}</button>
        </div>
    </mat-dialog-content>

</div>